import { laptopMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

const BenefitsChecklistContainer = styled.ul<{
  backgroundColor?: string;
  borderBottomLeftRadius?: number;
  borderBottomRightRadius?: number;
  padding?: string;
  maxWidth?: number;
  fontColor?: string;
}>`
  padding: ${(props) => (props.padding ? props.padding : `0px;`)};
  list-style: none;
  width: 100%;
  ${(props) => props.borderBottomRightRadius && `border-bottom-right-radius: ${props.borderBottomRightRadius}px;`}
  ${(props) => props.borderBottomLeftRadius && `border-bottom-left-radius: ${props.borderBottomLeftRadius}px;`}
  ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  ${(props) => props.maxWidth && `max-width:${props.maxWidth}px;`}
  ${(props) => (props.fontColor ? `color: ${props.fontColor}` : ``)};
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  @media screen and (${laptopMax}) {
    justify-content: space-around;
    border-radius: 0;
  }
`;

export default BenefitsChecklistContainer;
